var pug = require("!../../../../../node_modules/.pnpm/pug@2.0.1/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (actions, message) {pug_html = pug_html + "\u003Cdiv class=\"top_banner_flash blue\"\u003E\u003Ci class=\"close\"\u003E×\u003C\u002Fi\u003E\u003Cdiv class=\"actions\"\u003E";
// iterate actions
;(function(){
  var $$obj = actions;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var action = $$obj[pug_index0];
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("data-action", action, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = action) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var action = $$obj[pug_index0];
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("data-action", action, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = action) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cp class=\"message\"\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E";}.call(this,"actions" in locals_for_with?locals_for_with.actions:typeof actions!=="undefined"?actions:undefined,"message" in locals_for_with?locals_for_with.message:typeof message!=="undefined"?message:undefined));;return pug_html;};
module.exports = template;